export const CHANNEL_LIST_TYPES = {
	MANDATORY_ORDER: 'mandatory-order',
	MANDATORY: 'mandatory',
	ALTERNATIVE: 'alternative',
	BLACKLIST: 'blacklist',
}

export function getRetailShopId(retailShop) {
	if (!retailShop) {
		return ''
	}
	return retailShop.currentShopId || retailShop.shopId || ''
}

export function getShopDisplayName(item) {
	if (!item) {
		return ''
	}
	return item.mall_name || item.shop_name || ''
}

export function parseListResponse(data) {
	if (Array.isArray(data)) {
		return data
	}
	if (data && Array.isArray(data.list)) {
		return data.list
	}
	return []
}

export function mapChannelOption(item) {
	return {
		id: item.id,
		code: item.code || item.channel_code || '',
		name: item.name || item.channel_name || '',
	}
}

export function formatChannelLabel(item) {
	if (item.code && item.name) {
		return item.code + ' - ' + item.name
	}
	return item.name || item.code || ''
}

export function getRowChannelValue(row, keys) {
	const channel = row && row.channel ? row.channel : {}
	let i
	let key
	for (i = 0; i < keys.length; i++) {
		key = keys[i]
		if (channel[key] != null && channel[key] !== '') {
			return channel[key]
		}
	}
	return ''
}

export function mapChannelListRow(item) {
	const channel = item.channel && typeof item.channel === 'object' ? item.channel : {}

	return {
		id: item.id,
		channel_id: item.channel_id || channel.id || '',
		shop_name: getShopDisplayName(item),
		channel: channel,
		channel_code: getRowChannelValue({ channel: channel }, ['code', 'channel_code']),
		channel_name: getRowChannelValue({ channel: channel }, ['name', 'channel_name']),
		return_address: getRowChannelValue({ channel: channel }, ['return_address']) || item.return_address || '',
		state: normalizeChannelState(item),
		sort_order: item.sort_order != null ? item.sort_order : '',
		reason: item.reason || '',
	}
}

export function normalizeChannelState(item) {
	if (item.state != null && item.state !== '') {
		return Number(item.state)
	}
	if (item.is_enabled === true || item.is_enabled === 1 || item.is_enabled === '1') {
		return 1
	}
	if (item.is_enabled === false || item.is_enabled === 0 || item.is_enabled === '0') {
		return 2
	}
	return 1
}

export function stateToIsEnabled(state) {
	return state === 1 ? 1 : 0
}

let allChannelsCache = null
let allChannelsPromise = null
const shopChannelListInflight = {}

export function fetchAllChannels(axios, force) {
	if (!force && allChannelsCache) {
		return Promise.resolve(allChannelsCache)
	}
	if (!force && allChannelsPromise) {
		return allChannelsPromise
	}

	allChannelsPromise = axios.post('api/channel/list', {
		page: 1,
		limit: 99999,
	}).then(function(res) {
		if (res.data.code != 0) {
			throw new Error(res.data.message || '获取渠道列表失败')
		}
		allChannelsCache = parseListResponse(res.data.data).map(mapChannelOption)
		return allChannelsCache
	}).catch(function(err) {
		allChannelsPromise = null
		throw err
	}).then(function(result) {
		allChannelsPromise = null
		return result
	})

	return allChannelsPromise
}

export function fetchShopChannelList(axios, id, type, force) {
	const cacheKey = String(id) + ':' + type

	if (!force && shopChannelListInflight[cacheKey]) {
		return shopChannelListInflight[cacheKey]
	}

	shopChannelListInflight[cacheKey] = axios.post('api/retail_shop/channel_list', {
		retail_shop_id: id,
		type: type,
	}).then(function(res) {
		if (res.data.code != 0) {
			throw new Error(res.data.message || '获取渠道配置列表失败')
		}
		return parseListResponse(res.data.data).map(mapChannelListRow)
	}).finally(function() {
		delete shopChannelListInflight[cacheKey]
	})

	return shopChannelListInflight[cacheKey]
}

export function buildChannelSavePayload(retailShopId, type, options) {
	const payload = {
		retail_shop_id: retailShopId,
		type: type,
		channel_id: options.channel_id,
	}

	if (options.sort_order != null && options.sort_order !== '') {
		payload.sort_order = Number(options.sort_order)
	}

	if (options.reason != null && options.reason !== '') {
		payload.reason = options.reason
	}

	if (options.id != null && options.id !== '') {
		payload.id = options.id
	}

	return payload
}

export function buildChannelTogglePayload(row, state) {
	return {
		id: row.id,
		is_enabled: stateToIsEnabled(state),
	}
}

export function toggleShopChannelState(axios, row, state) {
	return axios.post('api/retail_shop/channel_toggle', buildChannelTogglePayload(row, state)).then(function(res) {
		if (res.data.code != 0) {
			throw new Error(res.data.message || '状态更新失败')
		}
		return res.data
	})
}

export function saveShopChannelState(axios, row, state) {
	return toggleShopChannelState(axios, row, state)
}

export function saveShopChannel(axios, payload) {
	return axios.post('api/retail_shop/channel_save', payload).then(function(res) {
		if (res.data.code != 0) {
			throw new Error(res.data.message || '保存失败')
		}
		return res.data
	})
}

export function deleteShopChannel(axios, id) {
	return axios.post('api/retail_shop/channel_delete', { id: id }).then(function(res) {
		if (res.data.code != 0) {
			throw new Error(res.data.message || '删除失败')
		}
		return res.data
	})
}

export function resetChannelFormAfterSave(vm, formRef, form, fields) {
	let i
	for (i = 0; i < fields.length; i++) {
		form[fields[i]] = ''
	}
	if (!vm || typeof vm.$nextTick !== 'function') {
		if (formRef && typeof formRef.clearValidate === 'function') {
			formRef.clearValidate(fields)
		}
		return
	}
	vm.$nextTick(function() {
		if (formRef && typeof formRef.clearValidate === 'function') {
			formRef.clearValidate(fields)
		}
	})
}



// WEBPACK FOOTER //
// ./src/components/StoreConfig/detailed/retailShopChannel.js